module.exports = __webpack_public_path__ + "static/media/bell.c9cfd61d.png";